import { useContext, useEffect, useState } from "react";
import CartItems from "../Components/CartIems";
import PurchaseForm from "../Components/forms/PurchaseForm";
import { CartContext } from "../context/CartContext";
import purchaseService from "../services/purchaseService";
import SpinnerOverlay from "../Components/SpinnerOverlay";
import { useNavigate } from "react-router-dom";
import CheckoutQR from "../Components/CheckoutQR";
import { useSearchParams } from "react-router-dom";
import { getFirstErrorMessage } from "../helpers/getErrorsMessages";
import { validateEmail } from "../helpers/validateEmail";
import PromotionCodeBox from "../Components/PromotionCodeBox";

const Cart = () => {
    const [userData, setUserData] = useState({});
    const { cartItems, total, cleanCart, serviceRate } = useContext(CartContext);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [activeModal, setActiveModal] = useState({
        isVisible: false,
        qr_code: null,
        url: null,
    });
    const [searchParams] = useSearchParams();
    const resellerCode = searchParams.get("code");
    const [termsyconditions, setTermsyconditions] = useState(false);
    const [promoData, setPromoData] = useState(null);
    const displayedTotal = promoData?.finalTotal ?? total;
    const displayedCostService = Math.trunc(displayedTotal * serviceRate);

    useEffect(() => {
        setPromoData(null);
    }, [cartItems]);

    const handleSubmit = async () => {
        try {
            const { email, dni, phone, confirmEmail, name, lastName } = userData;
            setError("");
            if (!email || !name || !lastName || !confirmEmail || !dni || !phone) {
                setError("Campos sin completar");
                return;
            }
            if (userData.email !== userData.confirmEmail) {
                setError("Los emails no coinciden");
                return;
            }
            if (!validateEmail(userData.email)) {
                setError("Email invalido");
                return;
            }
            if (
                userData.dni.length < 7 ||
                isNaN(userData.dni) ||
                !/^\d+$/.test(userData.dni)
            ) {
                setError("DNI invalido");
                return;
            }
            if (
                userData.phone.length < 8 ||
                isNaN(userData.phone) ||
                !/^\d+$/.test(userData.phone)
            ) {
                setError("Telefono invalido");
                return;
            }
            if (cartItems.length === 0) {
                setError("Carrito vacio");
                return;
            }
            if (!termsyconditions) {
                setError("Debe aceptar los terminos y condiciones");
                return;
            }
            setLoading(true);

            const response = await purchaseService.getPreference({
                userData,
                cartItems,
                total,
                cost: displayedCostService,
                reseller_code: resellerCode || null,
                promotionCode: promoData?.promotionCode,
            });

            setLoading(false);
            if (!response.data.free) {
                setActiveModal({
                    isVisible: true,
                    qr_code: response.data.qr_code,
                    url: response.data.url,
                });
            } else {
                cleanCart();
                navigate("/payment-approved");
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            const data = error.response.data;
            window.alert(
                data.error ||
                getFirstErrorMessage(data.errors) ||
                "Error al realizar la compra"
            );
        }
    };

    return (
        <div className="relative min-h-screen overflow-hidden bg-zinc-950 px-2 pb-10 pt-16 text-white sm:pt-16">
            <div
                className="pointer-events-none absolute inset-0 opacity-75"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 15% 20%, rgba(255, 74, 110, 0.20), transparent 34%), radial-gradient(circle at 85% 15%, rgba(59, 130, 246, 0.10), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                }}
            />
            <SpinnerOverlay isLoading={loading} />
            <div className="relative z-10">
                <CartItems />
                <PurchaseForm setUserData={setUserData}
                    setTermsyconditions={setTermsyconditions}
                    termsyconditions={termsyconditions}
                />
                <PromotionCodeBox cartItems={cartItems} onApplied={setPromoData} />
                {error && (
                    <div className="mx-auto mt-4 max-w-lg rounded-2xl border border-rose-400/30 bg-rose-500/10 px-4 py-3 shadow-[0_12px_30px_rgba(244,63,94,0.16)] backdrop-blur-sm">
                        
                        <p className="mt-1 text-sm text-center font-medium text-rose-100">
                            {error}
                        </p>
                    </div>
                )}
                <div className="mx-auto mt-8 max-w-lg rounded-2xl border border-zinc-800 bg-zinc-900 p-4 font-sans">
                    <p className="text-lg">
                        Subtotal:{" "}
                        {promoData && (
                            <span className="mr-2 text-sm line-through text-zinc-500">
                                ${new Intl.NumberFormat("de-DE").format(total)}
                            </span>
                        )}
                        <span className={promoData ? "text-emerald-300" : ""}>
                            ${new Intl.NumberFormat("de-DE").format(displayedTotal)}
                        </span>
                    </p>
                    <p className="mt-1 text-sm text-green-300">
                        Costo por servicio: $
                        {new Intl.NumberFormat("de-DE").format(displayedCostService)}
                    </p>
                    <p className="mt-3 text-lg">
                        Total: $
                        {new Intl.NumberFormat("de-DE").format(displayedTotal + displayedCostService)}
                    </p>
                </div>
                <CheckoutQR
                    isVisible={activeModal.isVisible}
                    qr_code={activeModal.qr_code}
                    url={activeModal.url}
                    activeModal={activeModal}
                    setActiveModal={setActiveModal}
                    navigate={navigate}
                />
                <div className="mx-auto max-w-lg">
                    <button
                        className="btn-primary my-8 w-full px-4 py-3 sm:w-32"
                        onClick={handleSubmit}
                    >
                        Comprar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cart;
